class CartRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    // Preserve the membership section before the innerHTML is replaced
    const membershipSection = this.querySelector('.drawer-membership-section');

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('cart-recommendations');
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
          // Only re-insert the saved membership section if the freshly-fetched
          // HTML didn't already include one (prevents duplicate rendering).
          if (membershipSection && !this.querySelector('.drawer-membership-section')) {
            this.insertBefore(membershipSection, this.firstChild);
          }
        }
      })
      .catch(e => {
        console.error(e);
      });
  }
}
customElements.define('cart-recommendations', CartRecommendations);
